import { Component, OnInit, OnChanges, Input } from '@angular/core';
import { FormGroup, FormArray, FormBuilder, FormControl } from '@angular/forms';

import { SimulationInfo } from '@classes/simulation/simulation-info';
import { SimulationService } from '@services/simulation.service';
import { ReportService } from '@services/report.service';
import { ReportSelectGroup } from '@classes/report/report-select-group';
import { Grouping } from '@classes/grouping/grouping';
import { NavService } from '@services/nav.service';
import { NavLink } from '@classes/nav-link';


@Component({
    selector: 'app-report-select-form',
    templateUrl: './report-select-form.component.html',
    styleUrls: ['./report-select-form.component.scss']
})
export class ReportSelectFormComponent implements OnInit, OnChanges {
    @Input() title: string;
    @Input() maxCompare = 3;
    @Input() compareType: 'simu' | 'group';
    @Input() selectItems: Grouping[] | SimulationInfo[];
    @Input() selectGroups: ReportSelectGroup[];
    @Input() years: number[];

    compareForm: FormGroup;
    isLoading: boolean;
    paramLink: NavLink;
    selectedYear: number;
    isComplete = false;
    values: string[];

    constructor(
        private simuSrv: SimulationService,
        private reportSrv: ReportService,
        private fb: FormBuilder,
        private navSrv: NavService
    ) {

    }

    ngOnInit() {
        this.initForm();

        this.simuSrv.selectedSimulationsSubject.next(null);
        this.reportSrv.reportDataSubject.next(null);

        if(this.compareType === 'group') {
            this.paramLink = this.navSrv.getLinkFromRoute(['parameters', 'grouping'], 'settings');
        }
    }

    ngOnChanges() {
        if (this.years && this.years[0])
        {
            this.selectedYear = this.years.slice(-1)[0];
            const year = (new Date()).getFullYear();
            if (this.years.includes(year))
                this.selectedYear = year;
        }
    }

    // Used to access to the control inside the template
    get selectList() {
        return this.compareForm.get('selectList') as FormArray;
    }

    onGetReport() {
        this.isLoading = true;
        const codesList: string[] = this.compareForm.value.selectList
            .filter((code, index, self) => code !== "" && code != null && self.indexOf(code) === index);

        if (codesList.length && (!this.years || this.selectedYear > 0)) {
            if (this.compareType === 'simu') {
                this.getSimuReport(codesList);
            } else {
                this.getGroupReport(codesList);
            }
        } else {
            this.isLoading = false;
        }
    }

    private getSimuReport(codesList: string[]): void {
        this.simuSrv.getList(codesList, this.selectedYear).subscribe();
        this.reportSrv.getBySimulation(codesList, 'default', this.selectedYear)
            .subscribe(() => {
                this.isLoading = false;
            }, () => {
                this.isLoading = false;
            });
    }

    private getGroupReport(codesList: string[]): void {
        this.reportSrv.getGroupsData(codesList, this.selectedYear).subscribe();
        this.reportSrv.getByGroup(codesList, this.selectedYear)
            .subscribe(() => {
                this.isLoading = false;
            }, () => {
                this.isLoading = false;
            });
    }

    private initForm(): void {
        this.values = new Array<string>(this.maxCompare);

        const controls: FormControl[] = [];
        for (let i = 0; i < this.maxCompare; i++) {
            controls.push(this.fb.control(''));

            controls[i].valueChanges.subscribe(value => {
                this.values[i] = value;
                this.isComplete = this.values.some(code => code !== "" && code != null);
            });
        }

        this.compareForm = this.fb.group({
            selectList: this.fb.array(controls)
        });
    }

}
